import get from 'lodash/get';
import identityConfig from '../../../config/identity';

export default function loadKruxTracker(currentState) {
  const siteName = get(currentState, 'context.site', 'fastcompany');
  const context = get(currentState, 'context', {});
  const siteConfig = identityConfig;
  const keywords = get(siteConfig, 'keywords', []);

  const { postData, type } = context;

  if (window.Krux) {
    const FCKruxFPA = {
      author: null,
      channels: null,
      subChannels: null,
      contentType: null,
      keywords: null,
      socialTags: null,
      siteName: null,
      referrerUrl: null,
      url: window.location.origin + window.location.pathname,
      querystring: null
    };

    let category = null;
    let authorName = siteName || '';
    let contentType = type;
    let readTime = '';
    const tags = [];
    let articleId = '';

    const typeMap = {
      post: 'article',
      gallery: 'slideshow',
      video: 'video'
    };

    // DO POST CHECK
    if (type === 'post') {
      category = get(postData, 'categories[0].slug', '');
      articleId = get(postData, 'id', null);
      authorName = get(postData, 'author.name', '');
      contentType = typeMap[get(postData, 'format', 'article')];
      readTime = get(postData, 'readTime');
    }

    FCKruxFPA['Read Length'] = readTime;
    FCKruxFPA['Article ID'] = articleId;
    FCKruxFPA.Subchannel = category;
    FCKruxFPA.Channel = category;

    if (window.location.search !== '') {
      FCKruxFPA.querystring = window.location.search;
    }

    if (document.referrer) {
      FCKruxFPA.referrerUrl = document.referrer;
    }

    FCKruxFPA.channels = keywords;
    FCKruxFPA.siteName = siteName;

    FCKruxFPA.author = authorName;
    FCKruxFPA.subChannels = category;
    FCKruxFPA.keywords = tags;
    FCKruxFPA.socialTags = tags;
    FCKruxFPA.contentType = contentType;

    window.FC_Krux_FPA = FCKruxFPA;

    if (window.Krux) {
      // eslint-disable-next-line new-cap
      window.Krux('ns:mansueto', 'page:load', () => true);
    }
  }
}
